// @ts-nocheck
import React from "react";
import { StatusBadge } from "@/components/ui";

export const OrderStatusBadge = ({ status }) => {
  const m = {
    Shipped: "ACTIVE",
    Processing: "PENDING",
    Delivered: "OK",
    Returned: "FAILED",
  };
  return (
    <StatusBadge status={m[status] || "DISABLED"} showDot>
      {status}
    </StatusBadge>
  );
};
